import type {Agent} from 'api/types';
import type {Schemas} from 'api/dto.generated';
import {transformErrorResponse} from 'store/api';
import {ebsApi} from 'store/ebsApi';
import {mapAgentDto, mapToPostPutAgentDto} from './mappers/mapAgent';
import {mapAuthority} from './mappers/mapAuthority';

const agentApi = ebsApi.injectEndpoints({
  endpoints: build => ({
    getAgent: build.query<Agent, Pick<Agent, 'id'>, Schemas.AgentDto>({
      query: ({id}) => `agent/${id}`,
      transformResponse: mapAgentDto,
      transformErrorResponse,
      providesTags: (_, __, {id}) => [{type: 'Agent', id}],
    }),
    mergeAgents: build.mutation<
      void,
      {target: Agent; source: Pick<Agent, 'id'>}
    >({
      query: ({target, source}) => ({
        url: `agent/${target.id}/merge/${source.id}`,
        method: 'PUT',
        //body: mapToUpsertAgentDto(target),
      }),
      invalidatesTags: (_, __, {target, source}) => [
        {type: 'Agent', id: target.id},
        {type: 'Agent', id: source.id},
      ],
    }),

    getAgentNorafDryRun: build.query<
      Schemas.Authority,
      {agent: Agent},
      Schemas.Authority
    >({
      query: ({agent}) => {
        return {
          url: `agent/${agent.id}/norafdryrun`,
          method: 'POST',
          body: mapToPostPutAgentDto('POST', agent, false),
        };
      },
      transformResponse: mapAuthority,
      transformErrorResponse,
    }),
  }),
});

export const {
  useLazyGetAgentNorafDryRunQuery,
  useGetAgentQuery,
  useMergeAgentsMutation,
} = agentApi;
